var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobs2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.333 85.3333H381.867C376.915 61.2568 363.815 39.6234 344.773 24.0793C325.732 8.53525 301.914 0.0310299 277.333 0L234.667 0C210.086 0.0310299 186.268 8.53525 167.227 24.0793C148.185 39.6234 135.085 61.2568 130.133 85.3333H106.667C78.3873 85.3672 51.2759 96.6162 31.2794 116.613C11.2828 136.609 0.0338743 163.721 0 192L0 256H512V192C511.966 163.721 500.717 136.609 480.721 116.613C460.724 96.6162 433.613 85.3672 405.333 85.3333ZM174.592 85.3333C178.988 72.898 187.12 62.1246 197.873 54.4872C208.627 46.8498 221.477 42.7213 234.667 42.6667H277.333C290.523 42.7213 303.373 46.8498 314.127 54.4872C324.88 62.1246 333.012 72.898 337.408 85.3333H174.592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.333 320C277.333 325.658 275.086 331.084 271.085 335.085C267.084 339.086 261.658 341.334 256 341.334C250.342 341.334 244.916 339.086 240.915 335.085C236.914 331.084 234.667 325.658 234.667 320V298.667H0V405.334C0.0338743 433.613 11.2828 460.724 31.2794 480.721C51.2759 500.718 78.3873 511.966 106.667 512H405.333C433.613 511.966 460.724 500.718 480.721 480.721C500.717 460.724 511.966 433.613 512 405.334V298.667H277.333V320Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs2);
export default __webpack_public_path__ + "static/media/Jobs 2.f40ae5679056af52b9bea9d9b242eb63.svg";
export { ForwardRef as ReactComponent };